import { Action } from "redux";

export class AppAction<T> implements Action {
  id?: number;
  type: string;
  payload?: T;
  error?: Error;
  meta?: any;
}